var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0113 5.46225C46.4578 3.32663 44.8367 1.64278 42.7807 1.06781C39.0245 0 23.9999 0 23.9999 0C23.9999 0 8.97525 0 5.21909 1.02674C3.20262 1.60171 1.542 3.32663 0.988464 5.46225C0 9.36385 0 17.4546 0 17.4546C0 17.4546 0 25.5863 0.988464 29.4469C1.542 31.5825 3.16308 33.2663 5.21909 33.8413C9.01479 34.9091 23.9999 34.9091 23.9999 34.9091C23.9999 34.9091 39.0245 34.9091 42.7807 33.8824C44.8367 33.3074 46.4578 31.6235 47.0113 29.4879C47.9998 25.5863 47.9998 17.4956 47.9998 17.4956C47.9998 17.4956 48.0393 9.36385 47.0113 5.46225Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7051 17.4541L19.2109 9.97949V24.9288L31.7051 17.4541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 34.9091,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.cd87599467280c13b6b886e020560004.svg";
export { ForwardRef as ReactComponent };